import React, { Component } from 'react';
import Card from 'components/Card/Card';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import CardBody from 'components/Card/CardBody';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import { dominioDemandaCirurgica } from '../../config/database';
import 'assets/css/anotacao.css';

class Anotacao extends Component {
  state = {
    anotacoes: [],
    globalFilter: null,
    first: 0,
    loading: false,
  };

  listarAnotacoes = () => {
    this.setState({ loading: true });
    dominioDemandaCirurgica
      .get(`/api/anotacaodetail/${this.props.pedidoCirurgia}/0/1`)
      .then(response => {
        this.setState({
          anotacoes: response.data,
          loading: false,
        });
      });
  };

  componentDidMount() {
    this.listarAnotacoes();
  }

  anotacaoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Anotação</span>
        <span>
          <p>{rowData.anotacao}</p>
        </span>
      </>
    );
  };

  render() {
    const header = (
      <>
        <div>
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={e => this.setState({ globalFilter: e.target.value })}
              placeholder="Pesquise pela descrição dos campos..."
              style={{ width: '50vw', height: '6vh' }}
            />
          </span>
        </div>
      </>
    );

    return (
      <>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <br />
            <Card>
              <CardBody className="card-body-0-padding">
                <div className="datatable">
                  <div className="card" id="tableAnotacao">
                    <DataTable
                      ref={el => (this.dt = el)}
                      value={this.state.anotacoes}
                      paginator
                      header={header}
                      globalFilter={this.state.globalFilter}
                      rows={5}
                      className="p-datatable-prime"
                      emptyMessage="Sem anotações"
                      loading={this.state.loading}
                      first={this.state.first}
                      onPage={e => {
                        this.setState({ first: e.first });
                        document.location.href = `${document.location.href.replace(
                          '#centroAnotacoes',
                          ''
                        )}#centroAnotacoes`;
                      }}
                      id="centroAnotacoes"
                    >
                      <Column
                        field="anotacao"
                        header="Anotação"
                        sortable
                        body={this.anotacaoBodyTemplate}
                        filter
                        filterPlaceholder="Anotação"
                        filterMatchMode="contains"
                      />
                    </DataTable>
                  </div>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </>
    );
  }
}

export default Anotacao;
